import React from 'react';
import { Button } from 'semantic-ui-react';
import * as Yup from 'yup';

import Form from 'src/components/form';
import { Typography } from 'src/components/coreUI/index';
import { useForm } from 'src/hooks';
import { AcceleratorPayload, createContact } from 'src/thunks/contact';
import { useAppDispatch } from 'src/store';

export type Props = {
  close?: Function;
};

const ContactForm: React.FC<Props> = ({ close }) => {
  const dispatch = useAppDispatch();
  const { submitForm, isSubmitting, getFieldInfo } =
    useForm<AcceleratorPayload>({
      initialValues: { email: '', message: '', phone: '', name: '' },
      async onSubmit(value) {
        await dispatch(createContact(value));
        close?.();
      },
      validationSchema: Yup.object().shape({
        name: Yup.string().required().max(255).label('Name'),
        email: Yup.string().email().max(255).required().label('Email'),
        message: Yup.string().required().label('Message'),
        phone: Yup.string().max(255).label('Phone'),
      }),
    });

  return (
    <Form>
      <Typography.Title>INTEREST FORM</Typography.Title>

      <Form.Input
        label="NAME"
        placeholder="Enter name"
        {...getFieldInfo('name')}
      />

      <Form.Input
        label="EMAIL"
        placeholder="Enter email"
        {...getFieldInfo('email')}
      />

      <Form.PhoneField label="PHONE" {...getFieldInfo('phone')} />

      <Form.TextArea
        label="MESSAGE"
        placeholder="Give us message"
        {...getFieldInfo('message')}
      />

      <div className="d-flex-right">
        <Button primary onClick={submitForm} loading={isSubmitting}>
          Send
        </Button>
      </div>
    </Form>
  );
};

export default ContactForm;
